export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4189f0659dbafa5a70edf4e9dbe288b6.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-slate-900/30 to-slate-900/40"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-20 py-32 relative z-10 w-full">
        <div className="grid grid-cols-2 gap-20 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-sky-50/90 backdrop-blur-sm rounded-full">
              <span className="text-sm font-medium text-slate-700">AI Strategy &amp; Implementation</span>
            </div>

            <h1 className="text-6xl font-extrabold text-white leading-tight">
              Leading Your AI Journey with Clarity and Confidence
            </h1>

            <p className="text-lg text-slate-100 leading-relaxed max-w-xl">
              NorthStar Innovations AI helps healthcare, financial, and professional service organizations implement intelligent systems that deliver measurable outcomes — without unnecessary complexity.
            </p>

            <div className="flex items-center gap-4 pt-4">
              <button
                onClick={() => scrollToSection('final-cta')}
                className="px-8 py-4 bg-slate-900 text-white rounded-full hover:bg-slate-800 transition-all duration-200 flex items-center gap-2 font-medium cursor-pointer whitespace-nowrap shadow-lg"
              >
                Schedule a Strategy Call
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
              <button
                onClick={() => scrollToSection('approach')}
                className="px-8 py-4 border-2 border-white text-white rounded-full hover:bg-white hover:text-slate-900 transition-all duration-200 font-medium cursor-pointer whitespace-nowrap"
              >
                Explore Our Approach
              </button>
            </div>

            <div className="pt-6 border-l-2 border-sky-400 pl-4">
              <p className="text-sm italic text-slate-200">
                Trusted by forward-thinking organizations navigating AI transformation.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%203D%20rendered%20visualization%20of%20AI%20and%20intelligent%20systems%20featuring%20floating%20geometric%20shapes%20including%20translucent%20cubes%20spheres%20and%20interconnected%20nodes%20with%20glowing%20connection%20lines%20in%20gradient%20blues%20whites%20and%20subtle%20cyan%20accents%20representing%20data%20flow%20and%20system%20architecture%20with%20clean%20minimalist%20composition%20and%20professional%20executive%20aesthetic%20on%20soft%20light%20background&width=800&height=900&seq=hero-visual-001&orientation=portrait"
                alt="AI System Architecture Visualization"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute bottom-8 right-8 bg-white rounded-2xl shadow-xl p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">40+</p>
                  <p className="text-sm text-slate-600">Trusted Organizations</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
